import { render, staticRenderFns } from "./ManualMovementList.vue?vue&type=template&id=856fe590&lang=pug"
import script from "./ManualMovementList.vue?vue&type=script&lang=js"
export * from "./ManualMovementList.vue?vue&type=script&lang=js"
import style0 from "./ManualMovementList.vue?vue&type=style&index=0&id=856fe590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports